/**
 * Navigation Component
 *
 * @constructor
 */

export default function()
{
    const body = document.querySelector('body')
    const triggerShow = document.getElementById('nav-trigger')
    const triggerHide = document.getElementById('close-nav')
    const mobileMenu = document.getElementById('mobile-menu')

    triggerShow.addEventListener('click', function(event){
        event.preventDefault()
        body.classList.add('nav-on')
    })

    triggerHide.addEventListener('click', function(event){
        event.preventDefault()
        body.classList.remove('nav-on')
        body.classList.add('nav-off')
        mobileMenu.addEventListener('animationend', function(){
            body.classList.remove('nav-off')
        })
    })

}
